<template>
  <div class="language-btn">
    
  </div>
</template>

<script>
export default {
  name: "LanguageBtn"
}
</script>

<style lang="less">
.pc-home {
  .language-btn {

  }
}
</style>
